import React, { useCallback, useEffect, useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import {
  ROUTE_PATHS,
  EXTERNAL_PAGE_URI,
} from "../../../common_nextgen/utils/Constants";
import { getBaseURL } from "../../../environment/BackendService";
import { useModal } from "../../../common_nextgen/hooks/ModalContext";
import { Button } from "primereact/button";
import {
  downloadCSV,
  getHostnameWithPath,
} from "../../../common_nextgen/utils/UtilFunctions";

const useDeductibleScheduleStepPatientPaySchedules = () => {
  const location = useLocation();
  const { showModal } = useModal();

  const {
    DEDUCTIBLE_SCHEDULE_STEPS,
    DISPLAY_DEDUCTIBLE_PATIENT_PAY_SCHEDULE,
    EDIT_DEDUCTIBLE_PATIENT_PAY_SCHEDULE,
    DISPLAY_DEDUCTIBLE_SCHEDULE_STEP,
    ADD_DEDUCTIBLE_PATIENT_PAY_SCHEDULE,
    DEDUCTIBLE_SCHEDULE,
  } = ROUTE_PATHS;
  /* const stateVal = location.state || [];
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  console.log("current state in form", currentState, previousState);
  const {
    selectedSteps = [],
    scheduleName = "",
    description = "",
    stepNumber = "",
    previousScreen = DEDUCTIBLE_SCHEDULE_STEPS,
    currentIndex: initialIndex = 0,
    selectedDepSeqNbrs,
    initialParamsData = {
      dscScheduleName: scheduleName,
      dsdStepNumber: stepNumber,
      dscDescription: description,
      depFromDate: selectedDepSeqNbrs?.[initialIndex]?.depFromDate ?? "",
      hiddenRecordIndicator: "A",
    },
  } = currentState;*/

  const [stateVal, setStateVal] = useState(location.state || []);
  const { currentState, previousState } = useMemo(() => {
    let [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];
    previousState.splice(stateVal.length - 1, 1);
    return {
      previousState,
      currentState,
    };
  }, [stateVal]);

  const {
    selectedSteps = [],
    scheduleName = "",
    description = "",
    stepNumber = "",
    previousScreen = DEDUCTIBLE_SCHEDULE_STEPS,
    currentIndex: initialIndex = 0,
    initialParamsData = {
      dscScheduleName: scheduleName,
      dsdStepNumber: stepNumber,
      dscDescription: description,
      depFromDate: "",
      hiddenRecordIndicator: "A",
    },
  } = useMemo(() => {
    const {
      selectedSteps,
      previousScreen,
      currentIndex,
      scheduleName,
      description,
      stepNumber,
      initialParamsData,
    } = currentState;
    return {
      selectedSteps,
      previousScreen,
      currentIndex,
      scheduleName,
      description,
      stepNumber,
      initialParamsData,
    };
  }, [currentState]);

  const [data, setData] = useState([]);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isInactiveConfirmationModalOpen, setIsInactiveConfirmationModalOpen] =
    useState(false);
  const [inactiveSelectedOption, setInactiveSelectedOption] = useState("no");
  const [inactiveFlag, setInactiveFlag] = useState(false);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const dsdStepNumber = stepNumber;
  const toast = useToast();
  const { axios_helper_no_header } = useAxios();

  const parmKey = "depSeqNbr";

  const [paramsData, setParamsData] = useState(initialParamsData);

  const screen_title = "Deductible Schedule Step Patient Pay Schedules";
  const screenNumber = "RCDEP001";

  const formFields = [
    {
      fieldLabel: "Schedule",
      name: "dscScheduleName",
      label: "Schedule",
      type: "text",
      fieldNature: "readOnly",
      maxLength: 10,
    },
    {
      fieldLabel: "Description",
      name: "dscDescription",
      label: "Description",
      type: "text",
      fieldNature: "readOnly",
      maxLength: 25,
    },
    {
      fieldLabel: "Step Number",
      name: "dsdStepNumber",
      label: "Step Number",
      type: "text",
      fieldNature: "readOnly",
      maxLength: 2,
    },
    {
      fieldLabel: "DEP From Date",
      name: "depFromDate",
      label: "From Date",
      type: "date",
      fieldNature: "editable",
      maxLength: 8,
    },
    {
      fieldLabel: "Hidden Records Indicator*Inactive",
      name: "hiddenRecordIndicator",
      label: "Status",
      type: "dropdown",
      fieldNature: "editable",
      maxLength: 20,
    },
  ];

  const dropdownOptions = [
    { field_label: "Hidden Records Indicator", condition: "*Inactive" },
  ];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  const ctaButtons = [
    {
      button_label: "Add Deductible Schedule Step Patient Pay Schedules",
      button_handeler: () => {
        navigateToPage(ADD_DEDUCTIBLE_PATIENT_PAY_SCHEDULE, [
          ...previousState,
          { ...currentState, currentIndex },
          {
            scheduleName: scheduleName,
            stepNumber: dsdStepNumber,
            description: description,
            previousScreen: location.pathname,
            currentIndex: 0,
          },
        ]);
      },
      button_key: "F6",
    },
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
  ];

  const menuOptions = [
    {
      label: "Edit",
      icon: <span className="material-icons">edit</span>,
      command: () => {
        editValidation();
      },
    },
    {
      label: "Inactivate",
      icon: <span className="material-icons">block</span>,
      command: () => {
        openInactiveConfirmationModal();
      },
    },
    {
      label: "Display",
      icon: <span className="material-icons">visibility</span>,
      command: () => {
        navigateToPage(DISPLAY_DEDUCTIBLE_PATIENT_PAY_SCHEDULE, [
          ...previousState,
          {
            ...currentState,
            currentIndex,
            selectedDepSeqNbrs: selectedRows.length ? selectedRows : [rowData],
          },
          {
            selectedDepSeqNbrs: selectedRows.length ? selectedRows : [rowData],
            scheduleName: scheduleName,
            stepNumber: stepNumber,
            description: description,
            previousScreen: location.pathname,
            currentIndex: 0,
          },
        ]);
      },
    },
  ];
  const viewPatientPayScheduleDetails = (schedule) => {
    /* showModal(
      { default: "" },
      {
        params: {
          lookupType: "external",
          fieldMapping: {
            default: [
              {
                source: "depPharmPatPaySchedule",
                target: "ps3PatientPaySchName",
                legacy: "ps3PatientPaySchName",
              },
              {
                source: "wrkDescription251",
                target: "ps3PatientPaySchDesc",
                legacy: "ps3PatientPaySchDesc",
              },
            ],
          },
          appName: "PATIENT_PAY",
          pageName: "PATIENT_PAY_SCHEDULE",
        },
      },
      null,
      { depPharmPatPaySchedule: schedule },
      true
    );*/
    const baseURL = getBaseURL("PATIENT_PAY");
    const uri = EXTERNAL_PAGE_URI["PATIENT_PAY_SCHEDULE_READ_ONLY"];
    console.log("abcd");
    const message = {
      message: "navigate-to-external-program",
      url: baseURL + uri,
      parameters: {
        state: [
          ...previousState,
          { ...currentState, currentIndex },
          {
            selectedPatients: [{ ps3PatientPaySchName: schedule }],
            previousScreen: getHostnameWithPath(window.location.href),
            currentIndex: 0,
          },
        ],
      },
    };
    console.log("back messages", message);
    window.parent.postMessage(message, "*");
  };

  /**default: [
          { source: "depPharmPatPaySchedule", target: "ps3PatientPaySchName",legacy:"ps3PatientPaySchName" },
          { source: "wrkDescription251", target: "ps3PatientPaySchDesc",legacy: "ps3PatientPaySchDesc" },
        ],
      },
      appName: "PATIENT_PAY",
      pageName: "PATIENT_PAY_SCHEDULE", */
  const columnDef = [
    {
      header: "From Date",
      field: "depFromDate",
    },
    {
      header: "Thru Date",
      field: "depThruDate",
    },
    {
      header: "Pharmacy Patient Pay Schedule",
      field: "depPharmPatPaySchedule",
      body: (rowData) => {
        // viewPatientPayScheduleDetails(rowData);
        return (
          <Button
            label={rowData.depPharmPatPaySchedule}
            link
            onClick={(e) => {
              viewPatientPayScheduleDetails(rowData["depPharmPatPaySchedule"]);
              // navigateToAccumsListDetails(rowData);
            }}
          />
        );
      },
    },
    {
      header: "Client Patient Pay Schedule",
      field: "depClientPatPaySchedule",
      body: (rowData) => {
        // viewPatientPayScheduleDetails(rowData);
        return (
          <Button
            label={rowData.depClientPatPaySchedule}
            link
            onClick={(e) => {
              viewPatientPayScheduleDetails(rowData["depClientPatPaySchedule"]);
              // navigateToAccumsListDetails(rowData);
            }}
          />
        );
      },
    },
    {
      header: "Status",
      field: "hiddenRecordIndicator",
    },
  ];

  const fetchData = async () => {
    const page = first / rows;
    try {
      if (
        paramsData.dscScheduleName &&
        paramsData.dsdStepNumber.toString().length
      ) {
        const raw_response = await axios_helper_no_header(
          "GET",
          `api/depDedSchDtlPatPaySchd`,
          null,
          {
            page: page,
            size: rows,
            ...paramsData,
          }
        );
        const response = raw_response.responseData;
        const pageResponse = raw_response.responsePaginationDTO;
        if (response.length === 0) {
          setData([]);
          setTotalRecords(0);
          /*toast.current.show({
            severity: "info",
            summary: "",
            detail: response?.responseStatus?.message,
            life: 3000,
          });*/
        } else {
          setData(response);
          setTotalRecords(pageResponse.totalRecords);
        }
      } else {
        setData([]);
        setTotalRecords(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    setParamsData({
      dscScheduleName: scheduleName,
      dsdStepNumber: dsdStepNumber,
      depFromDate: "",
      dscDescription: description,
      hiddenRecordIndicator: "A",
    });
  }, [dsdStepNumber]);

  const handleBack = useCallback(() => {
    if (currentIndex < selectedSteps.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      const [latestPreviousState] = previousState.splice(
        previousState.length - 1,
        1
      );
      let { paramsData } = latestPreviousState;
      console.log("paramsData", paramsData, latestPreviousState);
      const updatedParamsData = {
        ...paramsData,
        dscScheduleName: scheduleName,
      };
      const updatedLatestPreviousState = {
        ...latestPreviousState,
        initialParamsData: updatedParamsData,
      };
      navigateToPage(previousScreen, [
        ...previousState,
        updatedLatestPreviousState,
      ]);
    }
  }, [currentIndex, selectedSteps]);

  /* Top Left Back button info that needs to be displayed on the page*/
  const leftButtons = [
    { button_label: "Back", button_handeler: handleBack, button_key: "F12" },
  ];

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    fetchData();
  }, [paramsData, rows, currentPage, inactiveFlag, scheduleName]);

  useEffect(() => {
    if (currentIndex != initialIndex) {
      setParamsData({
        dscScheduleName: scheduleName,
        dsdStepNumber: selectedSteps[currentIndex].dsdStepNumber,
        dscDescription: description,
        depFromDate: "",
        hiddenRecordIndicator: "A",
      });
    }
  }, [currentIndex]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openInactiveConfirmationModal = () => {
    setIsInactiveConfirmationModalOpen(true);
  };

  const closeInactiveConfirmationModal = () => {
    console.log(inactiveSelectedOption);
    setIsInactiveConfirmationModalOpen(false);
    setInactiveSelectedOption("no");
  };

  const inactivateRecord = () => {
    if (inactiveSelectedOption === "yes") {
      const { dscScheduleName, dsdStepNumber } = paramsData;

      const params = {
        screenNumber: screenNumber,
        dscScheduleName: dscScheduleName,
        dsdStepNumber: dsdStepNumber,
        depSeqNbr: rowData[parmKey],
      };
      axios_helper_no_header(
        "PUT",
        "api/depDedSchDtlPatPaySchd/inactivateDepDedSchDtlPatPaySchd",
        null,
        params
      )
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          setInactiveFlag(!inactiveFlag);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeInactiveConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error inactivating the data!", error);
          const {
            responseStatus: { displayErrorFields = null, message } = {},
          } = error.data;
          toast.current.show({
            severity: "error",
            summary: "",
            detail: message,
            life: 3000,
          });
          closeInactiveConfirmationModal();
        });
    } else {
      closeInactiveConfirmationModal();
    }
  };

  const editValidation = () => {
    const { dscScheduleName, dsdStepNumber } = paramsData;
    const params = {
      dscScheduleName: dscScheduleName,
      dsdStepNumber: dsdStepNumber,
      depSeqNbr: rowData[parmKey],
    };
    axios_helper_no_header(
      "GET",
      "api/depDedSchDtlPatPaySchd/validateBeforeEdit",
      null,
      params
    )
      .then((response) => {
        navigateToPage(EDIT_DEDUCTIBLE_PATIENT_PAY_SCHEDULE, [
          ...previousState,
          {
            ...currentState,
            currentIndex,
            selectedDepSeqNbrs: selectedRows.length ? selectedRows : [rowData],
          },
          {
            selectedDepSeqNbrs: selectedRows.length ? selectedRows : [rowData],
            scheduleName: scheduleName,
            stepNumber: stepNumber,
            description: description,
            previousScreen: location.pathname,
            currentIndex: 0,
          },
        ]);
      })
      .catch((error) => {
        console.error("There was an error editing the data!", error);
        const { responseStatus: { displayErrorFields = null, message } = {} } =
          error.data;
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      });
  };

  const exportAsCSV = async () => {
    const {
      dscScheduleName,
      dsdStepNumber,
      depFromDate,
      hiddenRecordIndicator,
    } = paramsData;
    const params = {
      dscScheduleName,
      dsdStepNumber,
      depFromDate,
      hiddenRecordIndicator,
    };
    const queryParams = new URLSearchParams(params);
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/depDedSchDtlPatPaySchd/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  const handleMessage = (event) => {
    const { type, data } = event.data;

    if (type === "set-params") {
      setStateVal(data);
      //setExternalMode(true);
    }
    console.log("message", event.data);
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  });
  // console.log("object", selectedSteps[currentIndex]);
  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    leftButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    inactivateRecord,
    isInactiveConfirmationModalOpen,
    closeInactiveConfirmationModal,
    setInactiveSelectedOption,
  };
};

export default useDeductibleScheduleStepPatientPaySchedules;
